import config from '@juristat/config'

const activeGroupClaimKey = `${config.auth0Namespace}active_group` as const
const activeGroupNameKey = `${config.auth0Namespace}active_group_name` as const
const emailClaimKey = `${config.auth0Namespace}email` as const
const uuidClaimKey = `${config.auth0Namespace}uuid` as const

export { activeGroupClaimKey, activeGroupNameKey, emailClaimKey, uuidClaimKey }
